export const TOAST_DURATION = 20;
export const TOAST_DURATION_SHORT = 5;
